// Recursive PII/secret redactor for outbound Sentry events + breadcrumbs.
// Mirrors the backend policy so the two SDKs behave identically.

const SENSITIVE_KEY = /(authorization|cookie|password|passwd|reset[_-]?token|jwt|bearer|stripe[_-]?(secret|signing|webhook|key)|shopify[_-]?(access[_-]?token|api[_-]?secret)|google[_-]?(oauth|refresh|access)[_-]?token|api[_-]?key|client[_-]?secret|session[_-]?token|token_hash)/i;

const SENSITIVE_VALUE = [
  /Bearer\s+[A-Za-z0-9._\-]+/gi,
  /\beyJ[A-Za-z0-9_\-]+\.[A-Za-z0-9_\-]+\.[A-Za-z0-9_\-]+\b/g,   // JWT
  /(?:sk|rk)_(?:live|test)_[A-Za-z0-9]+/gi,                       // Stripe secret keys
  /whsec_[A-Za-z0-9]+/gi,                                         // Stripe webhook secret
  /(?:shpat|shpca|shppa|shpss)_[A-Za-z0-9_\-]+/gi,                // Shopify tokens
  /\b1\/\/[A-Za-z0-9_\-]{20,}/g,                                  // Google OAuth refresh
  /ya29\.[A-Za-z0-9_\-]+/g,                                       // Google access token
  /re_[A-Za-z0-9_]+/gi,                                           // Resend API key
];

const REDACT_MARK = "[Redacted]";

function redactString(value) {
  if (typeof value !== "string") return value;
  let out = value;
  for (const pattern of SENSITIVE_VALUE) out = out.replace(pattern, REDACT_MARK);
  out = out.replace(
    /([?&](?:token|access_token|refresh_token|reset_token|jwt|secret|password|api_key)=)[^&#\s]*/gi,
    "$1" + REDACT_MARK
  );
  return out;
}

export function redact(value, key = "") {
  if (key && SENSITIVE_KEY.test(key)) return REDACT_MARK;
  if (typeof value === "string") return redactString(value);
  if (Array.isArray(value)) return value.map((v) => redact(v, key));
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [k, redact(v, k)])
    );
  }
  return value;
}

export function sanitizeEvent(event) {
  return redact(event);
}

export function sanitizeBreadcrumb(breadcrumb) {
  return redact(breadcrumb);
}
